<div class="input-container gap-2" *transloco="let t; prefix: 'compliance.shared.filters'">
	@if(!isComplianceTasks) {
		@if(!isComplianceLibrary && !hideSearchInput) {
			<app-search class="text-dark" [placeholder]="t('searchCompliance')" [searchTerm]="request.searchTerm ?? ''" (searchTermUpdated)="onSearchTermUpdated($event)"></app-search>
		}
		<app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChanged($event)"></app-account-filter>
	}

	@if(hasComplianceRegionBtn) {
		<span ngbDropdown class="compliance-btn-container" ngbDropdownToggle>
			<input class="input-field text-dark" type="text"
				[readonly]="true"
				[disabled]="isLoadingRegions"
				[value]="isLoadingRegions ? t('loadingRegions') : (selectedComplianceRegion?.name || t('complianceRegion'))">
			<svg class="dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z" fill="#6B6D71"/>
			</svg>
			<div ngbDropdownMenu class="drop-down-scrollable"
				 infinite-scroll
				 [scrollWindow]="false"
				 (scrolled)="onRegionsScroll()">
				<button class="btn btn-outline" (click)="clearComplianceRegion()" ngbDropdownItem
					[class.active-item]="!selectedComplianceRegion">{{ t('all') }}</button>
				@for(region of visibleRegions; track region.type + '-' + region.id) {
					<div class="d-flex flex-column">
						<button class="btn btn-outline" (click)="selectComplianceRegion(region)" ngbDropdownItem
							[class.active-item]="selectedComplianceRegion?.id === region.id && selectedComplianceRegion?.type === region.type">{{ region.name }}</button>
					</div>
				}
			</div>
		</span>
	}
	@if(hasComplianceStandardBtn) {
		<span ngbDropdown class="compliance-btn-container" ngbDropdownToggle>
			<input class="input-field text-dark" type="text"
				[readonly]="true"
				[disabled]="isLoadingStandards"
				[value]="isLoadingStandards ? t('loading') : (selectedComplianceStandard?.name || t('complianceStandard'))">
			<svg class="dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z" fill="#6B6D71"/>
			</svg>
			<div ngbDropdownMenu class="drop-down-scrollable">
				<button class="btn btn-outline" (click)="selectComplianceStandard(null)" ngbDropdownItem
					[disabled]="complianceStandards.length === 0"
					[class.active-item]="!selectedComplianceStandard">
						@if(complianceStandards.length === 0) { {{ t('noStandardsFound') }} } @else { {{ t('all') }} }
				</button>
				@for(standard of complianceStandards; track standard.id) {
					<div class="d-flex flex-column">
						<button class="btn btn-outline" (click)="selectComplianceStandard(standard)" ngbDropdownItem
							[class.active-item]="selectedComplianceStandard?.id === standard.id">{{ standard.name }}</button>
					</div>
				}
			</div>
		</span>
	}
	@if(hasAssetTypesBtn && !isComplianceTasks && !isComplianceLibrary) {
		<span ngbDropdown class="compliance-btn-container" ngbDropdownToggle>
			<input class="input-field text-dark" type="text" [readonly]="true" [value]="assetTypeLabel">
			<svg class="dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  			<path d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z" fill="#6B6D71"/>
			</svg>
			<div ngbDropdownMenu class="drop-down-scrollable">
      	<div class="d-flex flex-column">
        	<button class="btn btn-outline" (click)="selectAssetType(null)" ngbDropdownItem>{{ t('all') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Truck)" ngbDropdownItem>{{ t('trucks') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Plane)" ngbDropdownItem>{{ t('planes') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Boat)" ngbDropdownItem>{{ t('boats') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Trailer)" ngbDropdownItem>{{ t('trailers') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Car)" ngbDropdownItem>{{ t('cars') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Motorbike)" ngbDropdownItem>{{ t('motorbikes') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Generator)" ngbDropdownItem>{{ t('generators') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Wagon)" ngbDropdownItem>{{ t('wagons') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.ATG)" ngbDropdownItem>{{ t('atg') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.YellowEquipment)" ngbDropdownItem>{{ t('yellowEquipment') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Container)" ngbDropdownItem>{{ t('containers') }}</button>
					<button class="btn btn-outline" (click)="selectAssetType(assetType.Van)" ngbDropdownItem>{{ t('vans') }}</button>
				</div>
    	</div>
		</span>
	}
	@if((!hasAssetTypesBtn || hasComplianceCalendarBtn) && !isComplianceTasks && !isComplianceLibrary) {
		<button class="calendar-btn" type="button" [routerLink]="['/asset-management/compliance-overview/calendar']">{{ t('complianceCalendar') }}</button>
	}
	@if(isComplianceLibrary) {
		<button class="btn btn-secondary upload-excel-btn" type="button" aria-expanded="false" (click)="uploadExcelClicked.emit()">
      <span>{{ t('uploadExcel') }}</span>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <rect width="24" height="24" fill="url(#pattern0_28988_88665)" />
        <defs>
          <pattern id="pattern0_28988_88665" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_28988_88665" transform="scale(0.02)" />
          </pattern>
          <image
            id="image0_28988_88665"
            width="50"
            height="50"
            preserveAspectRatio="none"
            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEQ0lEQVR4nO3Zb0wTdxzHcZ4rlNL27kxcUpKFLdmgtkgPitIWWlH+FOcmIMXgqi1/hpuMCaWItEBxTMyCcXOLE5Ea5cnGk5mNICHbGifJ3Fx2M1nczDBZlpnFLHFxINDP0usgQdpC2gs/s9w3eT9o0wf36u/3uzZtQoI44ogjzv9+UodrDyp99qtKn2M8llQTrhGN3zMeU1+5T2lvdCYJgTCn+hyIJ9VE+51MvwexpvF7PogbovQ5OkhDMv2e7+NfEZ/dTRqi8bs5EbI4IsT3tEGGbB7l4EGsqQuHkHrRTg5C9e7O2XSi1EEt1lMcqqvYwXjLxhjvbjA9wcpCdS9mAdMViu4q5V+z+d0qKM/b1h/C9JU1MCcsoHuDlYL2loDqKQbVXQSqqwgKzy4o3DuhcBdC3lkI+fEdkHeYITtmgqy9ADJXAVJc+UhpMyLFaQDVZvojta/ietr5Q188P1w3GSx9zPnplgnXZKylj7uurA7pLZ0SCiFt1SOlxYCs3hrknm2AfqiJ77nhup/jOmfD9h9X31ZeCycUQtqih/RoHrZ6a6A7Uw/9hXWFlHBCIpLf2k4KUsyFQ7CnbSj4sBHsgG0Z4hl3MYzv1cF4phZ0u2kFIrl5GxmIoqeIC7cSjaP9CM7M3CxefKdyaSVOfznCP++/eyu0Gk8gyEG6i7hw20nRWYgbv/7AX/S5r0d5xAtvl+PR4xnMzs9B278/LELyZi4hiKeIi3QmjO/XYyEQ4C9cfbIKI9+O8bC+a0MREZImHRmI3L2Li3awL33zWWgr/fIdFgILuPvnb2Bc5ogIyZEcQpDOnVy0u1Oadw/++uchFqdisDUqIumNbFKQHVy0W6yqrxJ/zz5aglQOOqMikl7Phrw0A1R5Jphqlk/aakDysfzYcxpm1gaJ8jlx7acpHvDR9VEEAgFMP/gdm5ymiIikwywhyHEzFwlRO9LDI+7cvwdFqxEf35rgHw9MXo6ISDysJQTpMHHhEM92WXD/4QP+wvdfbOe3k8q7F7PzjzG3MI/t/QfCIhIbs8hAZO0mLtzXjis3P+cRN+/dDh3u/87EOf8noeenb0PapFuBSHxtKyGIq4B7EhHMMGCHccCONE/ZsoO9uc0M/alXkdd/AHSzfgViYwMpSFsBF+0LYLS7UzjExvpMMpCUtnxOSMSGOg0ZiNRpmBISscGhJgRp1dcLhqhVI8mqgtyiWgah7Doo6nJjz6GbXhXCb68Wfbb0aJ5D0rxteUdyHNKazHHpPjUWSw5WuSVURTAVJMHKVZC+nAFZSTqol9SgK7KWIHFnZeP/OYiyZPQF3+E1VaaCYo+aXw1631MGoV9Re6m9GqypIKBCYES1UJBK1kNXabHWGKtWWES1UBAr6xb8wkRIHMNY2Q7yEG38f/RQ1ayZNIS2smcThBjaqrXRVu1VxqodX+9oK3tSZtMlCgIRRxxxxEkgNf8Cr5YkvJs7/z0AAAAASUVORK5CYII=" />
        </defs>
      </svg>
    </button>
		<button class="btn btn-secondary upload-excel-btn download-template-btn" type="button" (click)="downloadTemplateClicked.emit()">
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M7.99967 10.666L10.6663 7.33268H8.66634V2.66602H7.33301V7.33268H5.33301L7.99967 10.666Z" fill="#EE2737"/>
				<path d="M13.333 12.0007H2.66634V7.33398H1.33301V12.0007C1.33301 12.736 1.93101 13.334 2.66634 13.334H13.333C14.0683 13.334 14.6663 12.736 14.6663 12.0007V7.33398H13.333V12.0007Z" fill="#EE2737"/>
			</svg>
			<span>{{ t('downloadTemplate') }}</span>
		</button>
		<button class="add-custom-compliance-btn" (click)="addCustomClicked.emit()">{{ t('addCustomCompliance') }}</button>
	}
</div>